<template>
	<div class="reserve-background-width" style="max-width: 100% !important;  height: 100vh; width:1080px; overflow:auto; min-width:1080px;">
		<div v-if="step === '1'">
			<v-img
				v-if="eventsData.eventImg"
				:src="$store.state.frontServer_upload + eventsData.eventImg.url"
				@error="imgError()"
				@click="startEventWithPurpose()"
			></v-img>
			<v-img v-else-if="eventsData.eventImg === null" :src="defaultImg" class="imageButton"> </v-img>
		</div>
		<!-- step 2: 모바일 인증번호 입력 -->
		<div v-show="step === '2'">
			<main class="content_step3">
				<section class="info-header"><span class="mr-2">|</span> 인증번호 입력 <span class="ml-2">|</span></section>
				<div class="auth-header">
					<p class="bold">문자로 전송된 본인 인증번호를 입력해주세요.</p>
					<p>(문자 발송에는 약 10초~20초 소요됩니다.)</p>
				</div>
				<div class="auth-form">
					<div class="auth-input-container">
						<input type="text" id="auth-input" v-model="authCode" readonly />
					</div>
					<div class="keypad">
						<div class="keypad-row">
							<button class="key number-key" @click="addNumber('1')">1</button>
							<button class="key number-key" @click="addNumber('2')">2</button>
							<button class="key number-key" @click="addNumber('3')">3</button>
						</div>
						<div class="keypad-row">
							<button class="key number-key" @click="addNumber('4')">4</button>
							<button class="key number-key" @click="addNumber('5')">5</button>
							<button class="key number-key" @click="addNumber('6')">6</button>
						</div>
						<div class="keypad-row">
							<button class="key number-key" @click="addNumber('7')">7</button>
							<button class="key number-key" @click="addNumber('8')">8</button>
							<button class="key number-key" @click="addNumber('9')">9</button>
						</div>
						<div class="keypad-row">
							<button class="key clear-key" @click="clearAll()">전체<br />지움</button>
							<button class="key number-key" @click="addNumber('0')">0</button>
							<button class="key backspace-key" @click="backspace()">←</button>
						</div>
					</div>
				</div>
				<div class="action-button-container">
					<button class="action-button-outlined mr-4" @click="step = '3'">이전으로</button>
					<div class="nextButton_css" @click="submitAuthCode()">
						<span class="text">입력완료</span>
						<span class="arrow">&#8250;</span>
					</div>
				</div>
			</main>
		</div>
		<div v-show="step === '3'">
			<main class="content_step2">
				<section class="info-section">
					<section class="info-header"><span class="mr-2">|</span> 기본 정보 입력 <span class="ml-2">|</span></section>

					<div class="info-form">
						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">이 름</label>
								<v-flex xs12>
									<txtField
										class="placeholder-color-white font-size-30"
										:txtField="nametxtField"
										v-model="nametxtField.value"
										@input="disableNext()"
									></txtField>
								</v-flex>
							</v-layout>
						</div>

						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">전화번호</label>
								<v-layout wrap>
									<v-flex xs2>
										<select-box :sel="numSel" @change="change"></select-box>
									</v-flex>
									<v-flex xs10 class="pl-1">
										<txtField class="placeholder-color-white font-size-30" :txtField="numtxtField" v-model="numtxtField.value"></txtField>
									</v-flex>
								</v-layout>
							</v-layout>
						</div>

						<!-- 주소 (필수): dialog 에서 거제 / 통영 / 부산강서 → 동/읍/면, 기타지역 → 경남/부산/수도권/기타 -->
						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">주 소</label>
								<v-flex xs12>
									<button type="button" class="address-select-btn" @click="openAddressDialog">
										{{ addressDisplay ? addressDisplay : '주소 선택하기 ▸' }}
									</button>
								</v-flex>
							</v-layout>
						</div>

						<!-- 푸드트럭 이용권 매수 (참여자 전원, 1장 고정) -->
						<div class="form-group">
							<v-layout align-center>
								<label class="form-label form-label-small">푸드트럭<br />이용권</label>
								<div class="choice-group">
									<button
										v-for="n in foodTicketMax"
										:key="'foodsel' + n"
										type="button"
										class="choice-btn"
										:class="{ active: foodTicketCount === n }"
										@click="foodTicketCount = n"
									>
										{{ n }}장
									</button>
								</div>
							</v-layout>
						</div>

						<v-flex xs12>
							<v-layout wrap class="mt-4 keypad_background">
								<v-flex xs9>
									<keyboard_kr @onChange="onChange_kr" @onKeyPress="onKeyPress_kr" :input="nametxtField.value" />
								</v-flex>
								<v-flex xs3 class="pl-3">
									<keyboard_number @onChange="onChange_number" :input="numtxtField.value" />
								</v-flex>
							</v-layout>
						</v-flex>
					</div>
				</section>
				<!-- 개인정보 수집 · 이용 동의 (약관) -->
				<section class="info-section hsgeoje-terms">
					<section class="info-header"><span class="mr-2">|</span> 개인정보 수집 · 이용 동의 <span class="ml-2">|</span></section>
					<!-- 약관 수정 2.png: [필수] 개인정보 수집/이용 · [선택] 광고성 정보 수신 및 마케팅 활용 (2단) -->
					<div class="hsgeoje-terms-cols">
						<div v-for="term in termBlocks" :key="term.key" class="hsgeoje-term">
							<div class="hsgeoje-term-title">■ {{ term.title }}</div>
							<table class="hsgeoje-term-table">
								<tbody>
									<tr v-for="row in term.rows" :key="row.th">
										<th>
											<span v-for="(line, li) in row.th" :key="li" class="d-block">{{ line }}</span>
										</th>
										<td>
											<span v-if="row.quote" class="hsgeoje-term-quote">{{ row.quote }}</span>
											<span v-for="(line, li) in row.td" :key="'td' + li" :class="{ 'd-block': row.block }">{{ line }}</span>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="hsgeoje-term-note">
								<span v-for="(line, li) in term.note" :key="li" class="d-block">{{ li === 0 ? '※ ' : '' }}{{ line }}</span>
							</div>
							<div class="hsgeoje-term-agree">
								<div class="hsgeoje-term-q">{{ term.question }}</div>
								<div class="hsgeoje-term-options">
									<span class="hsgeoje-term-option" @click="setTermAgree(term.key, true)">
										<span class="hsgeoje-term-check" :class="{ active: $data[term.key] === true }">{{
											$data[term.key] === true ? '✔' : ''
										}}</span>
										동의
									</span>
									<span class="hsgeoje-term-option" @click="setTermAgree(term.key, false)">
										<span class="hsgeoje-term-check" :class="{ active: $data[term.key] === false }">{{
											$data[term.key] === false ? '✔' : ''
										}}</span>
										동의하지 않음
									</span>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section class="info-desc">
					<div class="next-button-container">
						<div class="nextButton_css" @click="submitForm">
							<span class="text">다음으로</span>
							<span class="arrow">&#8250;</span>
						</div>
					</div>
				</section>
			</main>
		</div>
		<v-dialog v-model="roulletDialog" overlay-opacity="0.9" eager persistent content-class="roullet_dialog">
			<div class="roullet_div">
				<img class="roullet_arrow" src="@/assets/images/roullet_arrow.png" />
				<img class="roullet_board" ref="roullet_board" :src="roulletImg" />
			</div>
		</v-dialog>
		<v-dialog v-model="lucky" width="90%" persistent content-class="check_dialog">
			<v-img :src="luckyImage" eager height="85vh" @click="print()" />
			<v-btn :color="btnColor" x-large dark @click="print()" block style="font-size: 36px;" height="64">
				경품권 + 푸드트럭 이용권 {{ foodTicketCount }}장 출력
			</v-btn>
		</v-dialog>
		<!-- 드래그 버전 설문 모달 -->
		<reservevisitModalDrag :setdialog="reserveDialog" :title="placeTitle" :eventsData="eventsData"></reservevisitModalDrag>
		<!-- 경품권(교환권) 인쇄 영역 : 경품권 원본(.ai) 배경 위에 당첨 상품명만 올린다 (event6 와 같은 방식) -->
		<div id="print-background-hsgeoje">
			<!-- 79x140mm 1장 고정 (브라우저 iframe / Electron 인쇄창 모두 이 스타일을 그대로 가져간다) -->
			<component :is="'style'">
				@page { size: 79mm 140mm; margin: 0; } html, body { margin: 0; padding: 0; }
			</component>
			<div
				style="position: relative; width: 79mm; height: 140mm; margin: 0; padding: 0; overflow: hidden; page-break-after: avoid; page-break-inside: avoid; background-color: #ffffff; font-family: 'Noto Sans KR', Arial, sans-serif;"
			>
				<img :src="ticketImg" style="display: block; width: 79mm; height: 140mm;" />
				<!-- 원본의 '경품명' 자리(구분선 아래 ~ 축하합니다 위, 세로 46% ~ 67%) 중앙에 상품명 배치 -->
				<div
					style="position: absolute; left: 0; right: 0; top: 46%; height: 21%; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 0 5%;"
				>
					<!-- 글자 크기: 원본 '경품명' 글자 높이(약 12mm)에 맞춤 -->
					<span style="font-size: 10mm; font-weight: 900; color: #000000; line-height: 1.2; text-align: center; word-break: keep-all;">
						{{ winnterProduct }}
					</span>
				</div>
			</div>
		</div>
		<!-- 푸드트럭 이용권 인쇄 영역 : 79x79mm × foodTicketCount 장 (경품권과 크기가 달라 별도 인쇄 작업으로 보낸다) -->
		<div id="print-food-hsgeoje">
			<component :is="'style'">
				@page { size: 79mm 79mm; margin: 0; } html, body { margin: 0; padding: 0; }
			</component>
			<div
				v-for="n in foodTicketCount"
				:key="'food' + n"
				:style="
					'width: 79mm; height: 79mm; margin: 0; padding: 0; overflow: hidden; page-break-inside: avoid; background-color: #ffffff;' +
						(n < foodTicketCount ? ' page-break-after: always;' : ' page-break-after: avoid;')
				"
			>
				<img :src="foodTicketImg" style="display: block; width: 79mm; height: 79mm;" />
			</div>
		</div>
		<v-dialog v-model="addressDialog" width="760" persistent content-class="address-dialog">
			<div class="address-dialog-content">
				<button class="address-close-btn" @click="closeAddressDialog">&#10006;</button>
				<div class="address-dialog-title">
					주소선택 <span class="address-dialog-step">({{ addressStep }}/2)</span>
				</div>
				<div class="address-dialog-subtitle" v-if="addressStep === 1">지역을 선택해 주세요.</div>
				<div class="address-dialog-subtitle" v-else>
					<span class="address-back-btn" @click="addressStep = 1">‹ 이전</span>
					{{ pickArea && pickArea.label }} · {{ pickArea && pickArea.etc ? '지역을' : '동/읍/면을' }} 선택해 주세요.
				</div>

				<div class="address-grid address-grid-area" v-if="addressStep === 1">
					<button
						v-for="area in areaList"
						:key="area.label"
						class="address-grid-btn"
						:class="{ active: pickArea && pickArea.label === area.label }"
						@click="selectArea(area)"
					>
						{{ area.label }}
					</button>
				</div>
				<div class="address-grid" v-else>
					<button
						v-for="dong in dongList"
						:key="dong"
						class="address-grid-btn"
						:class="{ active: addressDisplay === `${pickArea.label} ${dong}` }"
						@click="selectDong(dong)"
					>
						{{ dong }}
					</button>
				</div>
			</div>
		</v-dialog>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { alertModal5, keyboard_kr, keyboard_number, reservevisitModalDrag, selectBox, txtField } from '@/components/index.js'
import Hangul from 'hangul-js'
// 경품권 / 푸드트럭 이용권 이미지(data URI). 인쇄는 별도 iframe/윈도우에서 이루어져 상대경로가 깨지므로 인라인으로 사용한다.
import ticketImg from '@/assets/images/ticket_hsgeoje_base64.js'
import foodTicketImg from '@/assets/images/food_hsgeoje_base64.js'
export default {
	components: {
		txtField,
		selectBox,
		keyboard_kr,
		keyboard_number,
		reservevisitModalDrag,
		alertModal5,
	},
	metaInfo() {
		return {
			// 페이지 제목 캠페인 명에 따라 변경
			title: this.campaignTitle,
		}
	},
	data() {
		return {
			roulletImg: null,
			roulletDialog: false,
			ticketImg: ticketImg,
			foodTicketImg: foodTicketImg,
			// 푸드트럭 이용권 출력 매수 (1장 고정 - 2장 선택지 제거)
			foodTicketCount: 1,
			foodTicketMax: 1,
			// 주소 선택지. locationData 는 어드민 고객 상세(시도_시군구) 형식에 맞춘다.
			areaList: [
				{ label: '거제', sido: '경상남도', sigungu: '거제시' },
				{ label: '통영', sido: '경상남도', sigungu: '통영시' },
				{ label: '부산강서', sido: '부산광역시', sigungu: '강서구' },
				// 기타지역: 시도/시군구 대신 권역만 선택 (locationData 비움 → location 에 '기타지역 OO' 저장)
				{ label: '기타지역', etc: true },
			],
			// 경품 목록(1등~5등). 서버에서 내려오는 winnterProduct 표기가 조금씩 달라서 aliases 로 함께 매칭한다.
			prizeList: [
				{ rank: 1, name: 'LG 공기청정기', aliases: ['공기청정기'] },
				{ rank: 2, name: '테팔 프라이팬 SET', aliases: ['테팔', '프라이팬'] },
				{ rank: 3, name: '신라면 5개묶음', aliases: ['신라면', '라면'] },
				{ rank: 4, name: '물티슈 80매', aliases: ['물티슈'] },
				{ rank: 5, name: '직사각 갑티슈', aliases: ['갑티슈', '직사각'] },
			],
			prizeImages: {
				1: require('@/assets/images/1_hsgeoje.jpg'),
				2: require('@/assets/images/2_hsgeoje.jpg'),
				3: require('@/assets/images/3_hsgeoje.jpg'),
				4: require('@/assets/images/4_hsgeoje.jpg'),
				5: require('@/assets/images/5_hsgeoje.jpg'),
			},
			selectedPurpose: '',
			reserveCheckData: [],
			reserveCheckList: ['신문기사', '온라인광고', '홈페이지', 'TV광고', '차량광고'],
			// 약관 (약관 수정 2·3.png). privacyAgree: 필수 / marketingAgree: 선택 (기본값: 둘 다 동의)
			termBlocks: [
				{
					key: 'privacyAgree',
					title: '[필수] 개인정보 수집 / 이용 동의',
					rows: [
						{
							th: ['개인정보의', '수집 및 이용 주체'],
							// 키오스크 업체(코비플랜)도 개인정보를 다운로드하므로 수집·이용 주체에 포함 (약관 수정 3.png)
							td: ['옥포드림파크PFV(주), KB부동산신탁(주),', '현대엔지니어링(주), (주)와이낫플래닝,', '코비플랜'],
							block: true,
						},
						{ th: ['개인정보의', '수집 및 이용항목'], td: ['성명, 연락처, 주소'] },
						{ th: ['개인정보의', '수집 및 이용목적'], quote: "'힐스테이트 거제시그니처'", td: ['이벤트 진행'], block: true },
						{ th: ['개인정보의', '수집 및 보유기간'], quote: "'힐스테이트 거제시그니처'", td: [' 분양완료 후 30일'] },
					],
					note: [
						'위의 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다.',
						'그러나 동의를 거부할 경우 상담 및 이벤트에 제한을 받을 수 있습니다.',
						'위와 같이 개인정보를 수집 이용하는데에 동의하십니까?',
					],
					question: '위와같이 개인정보를 수집/이용하는데 동의하십니까?',
				},
				{
					key: 'marketingAgree',
					title: '[선택] 광고성 정보 수신 및 마케팅 활용 동의',
					rows: [
						{
							th: ['개인정보의', '수집 및 이용 주체'],
							td: ['옥포드림파크PFV(주), KB부동산신탁(주),', '현대엔지니어링(주), (주)와이낫플래닝'],
							block: true,
						},
						{ th: ['개인정보의', '수집 및 이용항목'], td: ['성명, 연락처, 주소'] },
						{
							th: ['개인정보의', '수집 및 이용목적'],
							quote: "'힐스테이트 거제시그니처'",
							td: ['분양정보에 대한 안내(전화 및 SMS)'],
							block: true,
						},
						{ th: ['개인정보의', '수집 및 보유기간'], quote: "'힐스테이트 거제시그니처'", td: [' 분양완료 후 30일'] },
					],
					note: [
						'위의 광고성 정보수신 및 마케팅 활용에 대한 동의를 거부할 권리가 있습니다.',
						'그러나 동의를 거부할 경우 분양정보에 대한 안내를 받으실 수 없습니다.',
						'위와 같이 광고성 정보수신 및 마케팅 활용하는데에 동의하십니까?',
					],
					question: '위와같이 개인정보를 마케팅으로 활용/이용하는데 동의하십니까?',
				},
			],
			privacyAgree: true,
			marketingAgree: true,
			agree: true,
			addressDialog: false,
			addressStep: 1,
			selectedSido: '',
			selectedSigungu: '',
			addressDisplay: '',
			// 지역별 동/읍/면 (어드민 location2 기준, 출장소 제외)
			dongData: {
				거제: [
					'거제면',
					'고현동',
					'남부면',
					'능포동',
					'동부면',
					'둔덕면',
					'사등면',
					'상문동',
					'수양동',
					'아주동',
					'연초면',
					'옥포1동',
					'옥포2동',
					'일운면',
					'장목면',
					'장승포동',
					'장평동',
					'하청면',
				],
				통영: [
					'광도면',
					'도산면',
					'도천동',
					'명정동',
					'무전동',
					'미수동',
					'봉평동',
					'북신동',
					'사량면',
					'산양읍',
					'욕지면',
					'용남면',
					'정량동',
					'중앙동',
					'한산면',
				],
				부산강서: ['가덕도동', '가락동', '강동동', '녹산동', '대저동1동', '대저동2동', '명지동1동', '명지동2동'],
				기타지역: ['경남', '부산', '수도권', '기타'],
			},
			pickArea: null, // dialog 1단계에서 고른 지역 (동 선택 전까지 기존 주소 유지)
			selectedDong: '',
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			numtxtField: {
				height: 50,
				color: 'white',
				label: '전화번호를 입력하세요',
				solo: true,
				dark: false,
				type: 'Number',
				value: '',
				onlyNumber: true,
				maxlength: 8,
				maxNumber: true,
				max: 99999999,
				readonly: true,
			},
			nametxtField: {
				height: 50,
				value: '',
				solo: true,
				readonly: true,
				label: '이름을 입력하세요',
				dark: false,
				color: 'white',
			},
			numSel: {
				value: '010',
				solo: true,
				class: 'selectNum',
				items: ['010', '011', '016', '017'],
				dark: false,
				color: 'white',
				height: 50,
			},
			authCode: '',
			step: '1',
			scheduleData: [
				{ type: '특별공급', date: '4.28', day: '월' },
				{ type: '1순위', date: '4.29', day: '화' },
				{ type: '2순위', date: '4.30', day: '수' },
			],
			houseInfo: [{ size: '84m²' }, { size: '101m²' }, { size: '108m²' }],
			totalUnits: 307,
			contactNumber: '1600.0255',

			footnotes: [
				'당첨 후 경품 수령시 성명, 연락처가 일치하여야만 경품 수령이 가능합니다.',
				'상기 경품 이미지는 실제와 다를 수 있습니다.',
				'해당 이벤트는 사은품 소진 수량 소진시 이벤트가 종료될 수 있습니다.',
				'경품 제세공과금(22%)은 소비자부담입니다.',
			],
			nameTxtArray: [],
			companyInfo: {
				name: '힐스테이트 거제시그니처',
				purpose: '성명, 연락처, 주소',
				usage: "'힐스테이트 거제시그니처' 분양정보에 대한 안내(전화, 문자) 및 경품추첨 등에 관한 일체 행위",
				retention: '분양완료 후 30일 이내',
				rights:
					'귀하께서는 개인정보수집 및 이용을 거절하실 수 있으며, 거절하실 경우 경품 당첨 등의 서비스를 제공해 드릴 수 없습니다. (개인정보제공에 동의하지 않으실 경우 경품 응모를 하실 수 없습니다.)',
			},
			marketing: {
				name: '힐스테이트 거제시그니처',
				purpose: '성명, 연락처, 주소',
				usage:
					'마케팅 정보제공에 동의 시 새로운 정보를 제공받으실 수 있으며, 각종 이벤트에도 참여할 수 있습니다.\n본 정보는 고객님이 동의한 활용목적으로만 사용하고 있습니다.',
				retention: '마케팅 정보 활용 동의 시점부터 1년간 (이후 폐기합니다. 본 동의 철회 시 즉시 폐기됩니다.)',
				rights: '귀하께서는 개인정보수집 및 이용을 거절하실 수 있으며,\n거절하실 경우 분양정보 안내 등의 서비스를 제공해 드릴 수 없습니다.',
			},
			eventsData: {},
			code: '',
			winnterProduct: '',
			eventJoinId: '',
			btnColor: '',
			lucky: false,
			luckyImage: '',
			// 응모권 출력(step 4) 경로 여부 - true면 룰렛 종료 후 경품권 프린트
			printMode: false,
			check_dialog: false,
			keypadInput: false,
			keyboardData: '',
			defaultImg: require('@/assets/images/main_hsgeoje.jpg'),
			placeTitle: '',
			nextbtn: {
				block: true,
				large: true,
				class: 'customBtn2',
				color: this.$store.state.PointColor7,
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			reserveDialog1: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: {
					value: '',
					outlined: true,
					placeholder: '성명을 입력하세요.',
					color: 'black',
				},
				numSel: {
					value: '010',
					outlined: true,
					class: 'selectNum',
					items: ['010', '011', '016', '017'],
					color: 'black',
				},
				numtxtField: {
					value: '',
					outlined: true,
					placeholder: '숫자만 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			alertModal2: {
				dialog: false,
				text: '',
			},
			noInputBox: false,
			campaignTitle: '힐스테이트 거제시그니처 룰렛이벤트',
			surveyLegnth: 0,
			agreeContent: '',
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData4: {}, // 내가받을 알림톡 알림톡 데이터
		}
	},

	async created() {
		// hsgeoje1 로 접속하면 행사일(KST)에 맞는 이벤트 코드로 자동 전환 (일자별 경품 구성이 달라 이벤트를 3개로 나눠 운영, 1등은 10/17)
		// 행사일: 관리자에 등록된 hsgeoje1~3 이벤트 기간 기준. 행사일이 아니면 라우트 코드 그대로 사용
		const hsgeojeCodeByDate = {
			'2026-10-16': 'hsgeoje1',
			'2026-10-17': 'hsgeoje2',
			'2026-10-18': 'hsgeoje3',
		}
		const todayKST = this.$moment()
			.utcOffset('+09:00')
			.format('YYYY-MM-DD')
		if (this.$route.params.code === 'hsgeoje1' && hsgeojeCodeByDate[todayKST]) {
			this.code = hsgeojeCodeByDate[todayKST]
		} else {
			this.code = this.$route.params.code
		}
		this.roulletImg = require('@/assets/images/rullet_hsgeoje.png')
		await this.events()
	},
	computed: {
		dongList() {
			return this.pickArea ? this.dongData[this.pickArea.label] : []
		},
	},
	methods: {
		print() {
			// 경품권(79x140mm) 1장 → 푸드트럭 이용권(79x79mm) N장. 용지 크기가 달라 인쇄 작업을 2번으로 나눈다.
			const ticket = document.getElementById('print-background-hsgeoje').innerHTML
			const food = document.getElementById('print-food-hsgeoje').innerHTML
			this.step = '1'
			this.lucky = false
			if (process.env.IS_ELECTRON) {
				const { ipcRenderer } = window.require('electron')
				ipcRenderer.send('print-document', ticket)
				setTimeout(() => {
					ipcRenderer.send('print-document', food)
				}, 1500)
			} else {
				this.printHtml(ticket, '79mm 140mm')
				setTimeout(() => {
					this.printHtml(food, '79mm 79mm')
				}, 2000)
			}
			setTimeout(() => {
				this.resetAfterPrint()
			}, 4000)
			return false
		},
		// 단일 영수증 HTML을 숨김 iframe으로 인쇄
		printHtml(printContent, pageSize = '79mm 140mm') {
			const printFrame = document.createElement('iframe')
			printFrame.style.position = 'fixed'
			printFrame.style.right = '0'
			printFrame.style.bottom = '0'
			printFrame.style.width = '0'
			printFrame.style.height = '0'
			printFrame.style.border = '0'
			document.body.appendChild(printFrame)
			const frameDoc = printFrame.contentWindow.document
			frameDoc.open()
			frameDoc.write(`
    <html>
      <head>
        <style>
          @page {
            size: ${pageSize}; /* 경품권 79x140mm / 푸드트럭 이용권 79x79mm */
            margin: 0;
          }
          body {
            margin: 0;
            padding: 0;
          }
        </style>
      </head>
      <body>${printContent}</body>
    </html>
  `)
			frameDoc.close()
			printFrame.contentWindow.focus()
			setTimeout(() => {
				printFrame.contentWindow.print()
				setTimeout(() => {
					document.body.removeChild(printFrame)
				}, 1000)
			}, 500)
		},
		// 인쇄 후 입력값 초기화
		resetAfterPrint() {
			this.authCode = ''
			this.numtxtField.value = ''
			this.nametxtField.value = ''
			this.nameTxtArray = []
			this.reserveCheckData = []
			this.agree = true
			this.privacyAgree = true
			this.marketingAgree = true
			this.foodTicketCount = 1
			this.addressDisplay = ''
			this.selectedSido = ''
			this.selectedSigungu = ''
			this.selectedDong = ''
			this.$store.state.loading = false
		},
		// 서버에서 내려온 경품명 → 경품 목록 매칭 (띄어쓰기/표기 차이 허용)
		findPrize(data) {
			if (!data) return null
			const key = String(data).replace(/\s/g, '')
			const exact = this.prizeList.find(p => p.name.replace(/\s/g, '') === key)
			if (exact) return exact
			return (
				this.prizeList.find(p =>
					[p.name, ...p.aliases].some(alias => {
						const a = alias.replace(/\s/g, '')
						return key.includes(a) || a.includes(key)
					}),
				) || null
			)
		},
		// 룰렛 대상 경품인지 여부 (미등록 경품이면 false → 문자 발송 경로)
		isPrize(data) {
			return this.findPrize(data) !== null
		},
		winnerRoulletIndex() {
			// rullet_hsgeoje.png 기준: 12시 우측부터 시계방향 10칸(360/10°), index i → 중심각 (i+0.5)*360/10°에 정지
			// 0:1등 1:2등 2:3등 3:4등 4:5등 5:1등 6:2등 7:3등 8:4등 9:5등 (등수별로 2칸씩 → 둘 중 한 칸에 무작위 정지)
			const prize = this.findPrize(this.winnterProduct)
			const index = prize ? prize.rank - 1 : 0
			return Math.random() < 0.5 ? index : index + 5
		},
		/****룰렛 돌리기
 자동으로 룰렛 돌리고 설정한 시간 이후 팝업 자동으로 닫히기
	 @author 전현균
 */
		spinRoullet() {
			this.roulletDialog = true

			let roullet_board = this.$refs.roullet_board

			roullet_board.style.transform = `rotate(${360 / 10 / 2}deg)`
			roullet_board.style.transition = `initial`

			const ready_second = 300 // 다이어로그 띄워지기 까지 대기 시간
			const spin_second = 1500 // 룰렛 돌아가는 시간
			const close_second = 300 // 룰렛 완료 후 대기 시간
			const spin_number = 10 // 룰렛 회전 횟수

			const product_total = 10 // 룰렛 칸 갯수
			// const index = 5
			// 룰렛 돌리고 원하는 위치에 룰렛 멈추기
			const winnerIndex = this.winnerRoulletIndex()
			const ran = Math.floor(winnerIndex * product_total)
			// const ran = Math.floor(index * product_total)

			const arc = 360 / product_total
			setTimeout(() => {
				const rotate = ran * arc - winnerIndex * arc + 360 * spin_number - arc + arc / 2
				// const rotate = ran * arc - index * arc + 360 * spin_number - 60 + arc / 2

				roullet_board.style.transform = `rotate(${rotate}deg)`
				roullet_board.style.transition = `${spin_second}ms cubic-bezier(0,0,0,.98)`

				var audio = new Audio('/roulette sound.mp3')
				audio.load()
				audio.volume = 1
				audio.play()
			}, ready_second)

			// 폭죽 효과
			setTimeout(() => {
				this.firework()
			}, spin_second + ready_second)

			// 룰렛 완료 후 룰렛 닫기
			setTimeout(() => {
				this.roulletDialog = false
				this.lucky = true
			}, spin_second + ready_second + close_second)
		},
		setCheck(label) {
			if (this.reserveCheckData.indexOf(label) > -1) this.reserveCheckData.splice(this.reserveCheckData.indexOf(label), 1)
			else this.reserveCheckData.push(label)
		},
		setAgree(val) {
			this.agree = val
		},
		setPrivacyAgree(val) {
			this.privacyAgree = val
		},
		// 약관 동의 선택 (privacyAgree: 필수 / marketingAgree: 선택)
		setTermAgree(key, val) {
			this[key] = val
		},
		proceedToForm() {
			if (!this.privacyAgree) {
				this.alertModal.text = '필수 동의 항목에 동의해주세요.'
				return (this.alertModal.dialog = true)
			}
			this.step = '3'
		},
		// 약관(step terms) 동의 후 기본 정보 입력(step 3)으로 이동
		goToInputForm() {
			if (!this.privacyAgree) {
				this.alertModal.text = '필수 동의 항목에 동의해주세요.'
				return (this.alertModal.dialog = true)
			}
			this.step = '3'
		},
		// 주소 선택 dialog: 1/2 지역(거제 / 통영 / 부산강서 / 기타지역) → 2/2 동/읍/면 (기타지역은 경남/부산/수도권/기타)
		openAddressDialog() {
			this.addressStep = 1
			this.pickArea = null
			this.addressDialog = true
		},
		selectArea(area) {
			this.pickArea = area
			this.addressStep = 2
		},
		selectDong(dong) {
			// 기타지역은 어드민 고객 상세(시도_시군구_동) 형식이 아니므로 locationData 를 비우고 location 으로만 저장
			const etc = !!this.pickArea.etc
			this.selectedSido = etc ? '' : this.pickArea.sido
			this.selectedSigungu = etc ? '' : this.pickArea.sigungu
			this.selectedDong = etc ? '' : dong
			this.addressDisplay = `${this.pickArea.label} ${dong}`
			this.closeAddressDialog()
		},
		closeAddressDialog() {
			this.addressDialog = false
			this.addressStep = 1
		},
		async eventJoins() {
			this.$store
				.dispatch('eventJoins', {
					code_in: [this.code],
					phone: String(this.numSel.value + this.numtxtField.value),
				})
				.then(res => {
					if (res.data.eventJoins.length > 0) {
						this.alertModal.text = '이미 응모하신 번호입니다.'
						this.$store.state.loading = false
						this.step = '1'
						this.numtxtField.value = ''
						this.nametxtField.value = ''
						this.nameTxtArray = []
						return (this.alertModal.dialog = true)
					} else this.startEvent()
				})
		},
		phoneCrypto(data) {
			return data.replace(/\d(?=\d{4})/g, '*')
		},
		// 경품 내용을 출력(프린트) 대신 문자(SMS)로 발송
		sendPrizeSms() {
			const phone = this.numSel.value + this.numtxtField.value
			const phoneDisplay = `${this.numSel.value}-${this.numtxtField.value.slice(0, 4)}-${this.numtxtField.value.slice(4)}`
			const prizeLink = `https://here-customer.web.app/eventPrize/${this.code}/${phone}/${this.eventJoinId}`
			const message =
				`힐스테이트 거제시그니처\n` +
				`룰렛 경품 이벤트\n` +
				`${this.nametxtField.value} 고객님\n` +
				`${phoneDisplay}\n` +
				`${this.winnterProduct}\n` +
				`${this.$moment().format('YYYY-MM-DD HH:mm')}\n` +
				`▶ 경품 수령 확인 : ${prizeLink}`

			const data = {
				receiver: phone,
				message: message,
				sender: 'LMS',
				senderkey: process.env.VUE_APP_SENDERKEY,
			}

			this.$store
				.dispatch('createSendSm', data)
				.then(() => {})
				.catch(err => {
					alert('경품 문자 발송 시 오류가 발생하였습니다. 다시 시도해 주세요.')
					console.log({ err })
				})
				.finally(() => {
					this.authCode = ''
					this.numtxtField.value = ''
					this.nametxtField.value = ''
					this.nameTxtArray = []
					this.agree = true
					this.privacyAgree = true
					this.marketingAgree = true
					this.reserveCheckData = []
					this.addressDisplay = ''
					this.selectedSido = ''
					this.selectedSigungu = ''
					this.selectedDong = ''
					this.step = '1'
					this.lucky = false
					this.$store.state.loading = false
				})

			return false
		},
		startEventWithPurpose(purpose) {
			this.selectedPurpose = purpose
			this.startEvent()
		},
		createEventJoin() {
			this.$store.state.loading = true
			let data2 = {
				name: this.nametxtField.value,
				phone: this.numSel.value + this.numtxtField.value,
				code: this.code,
				personalInformation: this.privacyAgree === true, // [필수] 개인정보 수집/이용 동의
				marketing: this.marketingAgree === true, // [선택] 광고성 정보 수신 및 마케팅 활용 동의 (어드민 고객관리 노출)
				purpose: this.selectedPurpose,
				// 어드민 고객 상세(시도_시군구_동) 형식
				locationData: [this.selectedSido, this.selectedSigungu, this.selectedDong].filter(Boolean).join('_'),
			}
			// 거주지역 (주소선택 시 location에 저장)
			if (this.addressDisplay) {
				data2['location'] = this.addressDisplay
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			this.$store
				.dispatch('createEventJoin', data2)
				.then(res => {
					if (res.data.createEventJoin.eventJoin.name === '이벤트 종료') {
						this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
						this.alertModal.dialog = true
						this.$store.state.loading = false
					} else if (res.data.createEventJoin.eventJoin.name === '중복번호') {
						this.alertModal.text = '본 이벤트는 중복 참여가 불가능합니다.'
						this.alertModal.dialog = true
						this.$store.state.loading = false
					} else {
						this.winnterProduct = res.data.createEventJoin.eventJoin.winnterProduct
						this.eventJoinId = res.data.createEventJoin.eventJoin.id
						if (this.isPrize(res.data.createEventJoin.eventJoin.winnterProduct)) {
							this.luckyImage = this.imageUrl(res.data.createEventJoin.eventJoin.winnterProduct)
							setTimeout(() => {
								this.spinRoullet()
							}, 500)
							this.check_dialog = false
						} else {
							setTimeout(() => {
								this.sendPrizeSms()
							}, 1000)
						}
					}
				})
				.catch(err => {
					// 서버가 id 없는 응답(중복번호/이벤트 종료)을 주면 GraphQL 오류로 떨어진다 → 로딩 해제 후 안내
					console.log({ err })
					this.$store.state.loading = false
					this.step = '1'
					this.alertModal.text = '이미 참여하셨거나 이벤트가 종료되어 참여할 수 없습니다.'
					this.alertModal.dialog = true
				})
		},
		async eventJoinsConnection() {
			await this.$store.dispatch('eventJoinsConnection', { code: this.code }).then(res => {
				if (this.eventsData.maxcount < res.data.eventJoinsConnection.aggregate.count) {
					this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					return (this.alertModal.dialog = true)
				}
			})
		},
		async events() {
			this.$store.state.loading = true
			const data = {
				code: this.code,
			}
			await this.$store
				.dispatch('events', data)
				.then(res => {
					if (res.data.events.length === 0) {
						this.$router.push({ name: 'notfound' })
					}
					this.eventsData = res.data.events[0]
					this.$store.state.loading = false
					this.eventJoinsConnection()
					if (this.eventsData.business) {
						this.nextbtn.color = this.eventsData.business.color
						this.btnColor = this.eventsData.business.color
					}
				})
				.catch(err => {
					console.log(err)
				})
		},
		change() {
			return {}
		},

		async submitForm() {
			if (!this.privacyAgree) {
				this.alertModal.text = '[필수] 개인정보 수집 / 이용에 동의해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.nametxtField.value) {
				this.alertModal.text = '이름을 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.numtxtField.value) {
				this.alertModal.text = '전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}

			if (this.numtxtField.value.length < 8) {
				this.alertModal.text = '최소 7자리의 올바른 전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.addressDisplay) {
				this.alertModal.text = '주소(동/읍/면)를 선택해주세요.'
				return (this.alertModal.dialog = true)
			}
			// 테스트 번호(010-0000-0000): 인증번호 없이 바로 이벤트 참여 + 룰렛
			if (this.numtxtField.value === '00000000') {
				return this.createEventJoin()
			}
			// 중복 참여 불가 이벤트면 인증번호 발송 전에 오늘(KST) 참여 이력 확인 (서버 createEventJoin 과 같은 기준)
			if (!this.eventsData.duplicate && (await this.isJoinedToday())) {
				this.alertModal.text = '본 이벤트는 중복 참여가 불가능합니다.'
				return (this.alertModal.dialog = true)
			}
			// 인증번호 문자 발송 → 인증번호 입력(step 2) → 인증 성공 시 이벤트 참여/룰렛 → 경품권 출력
			this.authCode = ''
			this.sendAuthSms()
			this.step = '2'
		},
		// 오늘(KST) 같은 이벤트 코드로 이 번호의 참여 이력이 있는지
		async isJoinedToday() {
			const now = this.$moment().utcOffset('+09:00')
			this.$store.state.loading = true
			try {
				const res = await this.$store.dispatch('eventJoins', {
					code: this.code,
					phone: String(this.numSel.value + this.numtxtField.value),
					sdate: now
						.clone()
						.startOf('day')
						.toISOString(),
					edate: now
						.clone()
						.endOf('day')
						.toISOString(),
				})
				return res.data.eventJoins.length > 0
			} catch (err) {
				console.log(err)
				return false
			} finally {
				this.$store.state.loading = false
			}
		},
		startEvent() {
			if (this.step === '1') {
				// 서버로부터 받은 이벤트 시작/종료 날짜를 한국 시간으로 변환
				const startDate = this.$moment(this.eventsData.start).utcOffset('+09:00')
				const endDate = this.$moment(this.eventsData.end).utcOffset('+09:00')
				const currentDate = this.$moment().utcOffset('+09:00')
				// 현재 시간이 이벤트 기간 내인지 확인
				const isEventActive = currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate)
				if (isEventActive) {
					this.eventJoinsConnection()
					this.step = '3'
				} else if (currentDate.isBefore(startDate)) {
					this.alertModal.text = '이벤트가 아직 시작되지 않았습니다.'
					return (this.alertModal.dialog = true)
				} else {
					this.alertModal.text = '이벤트가 종료되었습니다.'
					return (this.alertModal.dialog = true)
				}
			}
		},
		// SMS 인증번호 발송
		sendAuthSms() {
			const phone = this.numSel.value + this.numtxtField.value
			let randomCode = Math.floor(Math.random() * 900000) + 100000
			const message = `[힐스테이트 거제시그니처 이벤트 인증] 휴대전화 인증번호는 [${randomCode}] 입니다.`
			const data = {
				receiver: phone,
				message: message,
				authCode: String(randomCode),
				sender: 'LMS',
				senderkey: process.env.VUE_APP_SENDERKEY,
			}
			this.$store
				.dispatch('createSendSm', data)
				.then(() => {})
				.catch(err => {
					this.alertModal.text = '인증번호 발송 중 오류가 발생하였습니다. 다시 시도해 주세요.'
					this.alertModal.dialog = true
					console.log({ err })
				})
		},
		// 인증 키패드
		addNumber(number) {
			if (this.authCode.length < 6) this.authCode += String(number)
		},
		clearAll() {
			this.authCode = ''
		},
		backspace() {
			this.authCode = this.authCode.slice(0, -1)
		},
		submitAuthCode() {
			if (this.authCode.length > 0 && this.authCode.length < 7) {
				this.authCodecheck()
			} else {
				this.alertModal.text = '인증번호 6자리를 입력해주세요.'
				this.alertModal.dialog = true
			}
		},
		// 인증번호 서버 검증 → 성공 시 이벤트 참여 + 룰렛
		async authCodecheck() {
			const data = {
				receiver: this.numSel.value + this.numtxtField.value,
				authCode: String(this.authCode),
				limit: 1,
			}
			await this.$store.dispatch('sendSms', data).then(res => {
				if (res.data.sendSms.length > 0) {
					this.createEventJoin()
				} else {
					this.alertModal.dialog = true
					this.alertModal.text = '인증번호가 틀렸습니다.'
				}
			})
		},
		onChange_kr() {
			this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
		},
		onKeyPress_kr(button) {
			if (button === '{retry}') {
				this.nametxtField.value = ''
				this.nameTxtArray = []
			} else {
				if (button !== '{bksp}') {
					this.nameTxtArray.push(button)
				} else {
					if (this.nameTxtArray.length > 0) {
						this.nameTxtArray.splice([this.nameTxtArray.length - 1], 1)
						this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
					}
				}
			}
		},
		onChange_number(input) {
			if (input.length < 9) this.numtxtField.value = input
		},
		nameCrypto(name) {
			if (name.length === 1) {
				return name
			} else if (name.length === 2) {
				return name.slice(0, 1) + '*'
			} else {
				return name.slice(0, 1) + '*'.repeat(name.length - 2) + name.slice(-1)
			}
		},
		print_test() {
			var initBody
			window.onbeforeprint = () => {
				initBody = document.body.innerHTML
				document.getElementById('back-setting').style.backgroundColor = 'black'
				document.body.innerHTML = document.getElementById('print').innerHTML
			}
			window.onafterprint = () => {
				document.getElementById('back-setting').style.backgroundColor = 'white'
				document.body.innerHTML = initBody
			}
			window.print()
			return false
		},
		cancel() {
			this.nameTxtArray = []
			this.keypadInput = false
			this.agree = true
			this.privacyAgree = true
			this.marketingAgree = true
			this.nametxtField.value = ''
			this.numSel.value = '010'
			this.numtxtField.value = ''
			this.reserveCheckData = []
			this.selectedPurpose = ''
			this.addressDisplay = ''
			this.selectedSido = ''
			this.selectedSigungu = ''
			this.selectedDong = ''
		},
		terms(id) {
			const data = {
				stat: 1,
				id: id,
			}
			this.$store.dispatch('terms', data).then(res => {
				if (res.data.terms.length > 0) {
					this.agreeContent = res.data.terms[0].content
				}
			})
		},

		imgError() {
			this.eventsData.eventImg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
			if (dateIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
				this.surveyLegnth--
			}
			let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
			if (timeIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
				this.surveyLegnth--
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.eventsData.population || this.eventsData.population === '설정 해제') {
						if (this.eventsData.accessPhones !== '' && this.Data.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.reserveusers()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},

		disableNext() {},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.eventsData.accessPhones
				.filter(x => x.name === this.startDialog.nametxtField.value)
				.map(x => x.phone)
				.indexOf(realPhone)
			if (nameCheck !== -1) {
				this.reserveusers()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		imageUrl(data) {
			const prize = this.findPrize(data)
			return prize ? this.prizeImages[prize.rank] : ''
		},
		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData1.message === undefined) {
				this.cancel()
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, this.placeTitle)
				this.messageData1.message = this.messageData1.message.replace(/#{고객명}/g, this.nametxtField.value)
				this.messageData1.message = this.messageData1.message.replace(/#{예약신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{예약일시}/g, today)
				// this.messageData1.message = this.messageData1.message.replace(/#{고객정보}/g, url)
			}
			const data = {
				// 필수값

				code: this.code,
				sender: this.messageData1.smssender,
				senderkey: this.messageData1.senderkey,
				tpl_code: this.messageData1.tplCode,
				receiver_1: this.numSel.value + this.numtxtField.value,
				subject_1: this.messageData1.tplCodeStr,
				message_1: this.messageData1.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.nametxtField.value,
				failover: 'Y',
				fsubject_1: this.messageData1.tplCodeStr,
				fmessage_1: this.messageData1.message,
				button_1: this.messageData1.button ? this.messageData1.button : '[]',
				pay: this.eventsData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {
					this.cancel()
				})
				.catch(() => {})
		},
		// 내가받을 알림톡 알림톡
		messages() {
			const data = {
				// tplCode: this.$store.state.reservedayTplCode,
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					let foundIndex1 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[1]
					})
					if (foundIndex1 !== -1) {
						this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
					}
					this.creaetSendMessage()
				})
				.catch(() => {})
		},

		/**** 폭죽놀이
			 @author 전현균
		 */
		firework() {
			const defaults = { startVelocity: 25, spread: 360, ticks: 50, zIndex: 9998 }
			function randomInRange(min, max) {
				return Math.random() * (max - min) + min
			}
			const particleCount = 50 // 줄임
			let count = 0
			let interval = setInterval(() => {
				if (count > 1) {
					// 반복 2회만
					clearInterval(interval)
				}
				count++
				window.confetti(
					Object.assign({}, defaults, {
						particleCount,
						origin: { x: randomInRange(0.2, 0.4), y: Math.random() - 0.2 },
					}),
				)
				window.confetti(
					Object.assign({}, defaults, {
						particleCount,
						origin: { x: randomInRange(0.6, 0.8), y: Math.random() - 0.2 },
					}),
				)
			}, 400) // 간격도 약간 늘림
		},

		/**** 무기명 참여
 * name : 무기명, phone : 00000000000 으로 데이터 고정
 * 나머지는 로직은 동일
	 @author 전현균
 */
		noPhoneStart() {
			let data2 = {
				name: '무기명',
				phone: '00000000000',
				code: this.code,
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			this.$store.dispatch('createEventJoin', data2).then(res => {
				if (res.data.createEventJoin.eventJoin.name === '이벤트 종료') {
					this.alertModal2.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					this.alertModal2.dialog = true
				} else if (res.data.createEventJoin.eventJoin.name === '중복번호') {
					this.alertModal2.text = '본 이벤트는 중복 참여가 불가능합니다.'
					this.alertModal2.dialog = true
				} else {
					this.winnterProduct = res.data.createEventJoin.eventJoin.winnterProduct
					this.eventJoinId = res.data.createEventJoin.eventJoin.id
					if (this.isPrize(res.data.createEventJoin.eventJoin.winnterProduct)) {
						this.luckyImage = this.imageUrl(res.data.createEventJoin.eventJoin.winnterProduct)
						setTimeout(() => {
							this.spinRoullet()
						}, 500)
						// setTimeout(() => {
						// 	this.lucky = true
						// }, 1000)

						this.check_dialog = false
					} else {
						setTimeout(() => {
							this.sendPrizeSms()
						}, 1000)
					}
				}
				this.$store.state.loading = false
			})
		},
	},
}
</script>

<style lang="scss">
@page {
	size: auto; /* auto is the initial value */
	margin: 5mm; /* this affects the margin in the printer settings */
}

#print-background {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
#print {
	display: none;
}
.check_re_btn {
	width: 200px !important;
	height: 45px !important;
}
.check_complete {
	width: 200px !important;
	height: 45px !important;
}
.infoBackground {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	min-width: 90px;
	min-height: 90px;
	margin-bottom: 10px;
	.infoYear {
		background-color: white;
		color: black;
		font-size: 14px;
		border-radius: 10px 10px 0px 0px;
	}
	.infoHour {
		font-size: 14px;
		font-weight: 100;
	}
}
.v-dialog:not(.v-dialog--fullscreen) {
	max-height: 95% !important;
}
.check_dialog {
	padding: 20px;
	background-color: #ececec;
	.check_layout {
		background-color: white;
		border-radius: 10px;
		padding: 20px;
		.check_sub_layout {
			padding-left: 100px;
		}
		.check_title {
			text-align: center;
			font-size: 47px;
			font-weight: bold;
			color: #631115;
		}
		.check_sub_title {
			font-size: 18px;
			font-weight: bold;
			color: #631115;
		}
		.check_info {
			font-size: 17px;
			padding-left: 35px;
			color: #707070;
		}
	}
}
.radio_label_white {
	label {
		color: white !important;
	}
}
.keypad_btn {
	width: 230px;
	height: 69px !important;
	background-color: white !important;
	font-weight: bold !important;
	border-radius: 15px !important;
	font-size: 26px !important;
}
.keypad_background {
	background-color: rgba(255, 255, 255, 0.43);
	border-radius: 18px;
	padding: 8px;
}

.placeholder-color-white {
	.v-input__control {
		.v-input__slot {
			.v-text-field__slot {
				input {
					font-size: 28px !important;
				}
			}
		}
	}
}
.selectNum {
	.v-select__selection {
		font-size: 20px !important;
	}
	input {
		font-size: 20px !important;
	}
}
.keypad_agree_content {
	border: 1px solid;
	border-color: rgba(255, 255, 255, 0.5);
	border-radius: 15px;
	white-space: break-spaces;
	color: white;
	font-size: 11px;
	padding: 8px;
	text-align: left;
	height: auto;
	max-height: 276px;
	overflow: auto;
}
.reserve_keypad_maintxt {
	font-size: 24px;
	font-weight: bold;
	color: white;
}
.reserve_keypad_subtxt {
	font-size: 20px;
	color: white;
}
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}

.startVisit {
	background: white !important;
	padding: 20px 0px;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
.dialogBottom {
	.title {
		height: 50px;
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #fdc85a;
		padding: 0 10px 0 30px;

		h2 {
			color: white;
			font-weight: bold;
			font-size: 18px;
		}

		.title-icon {
			color: white;
		}
	}
	.dialog-content {
		padding: 20px 20px 20px 20px;
	}
}
.hiddenTab {
	display: none;
}

.roullet_dialog.v-dialog {
	overflow: hidden;
	background: transparent;
	box-shadow: none;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}
</style>
<style lang="scss" scoped>
.start-button-group {
	position: absolute !important;
	bottom: 300px;
	display: flex;
	gap: 30px;
	justify-content: center;
	width: 100%;
}
.start-button {
	background-color: #a20c2c;
	color: #fff;
	padding: 20px 60px;
	font-size: 64px;
	line-height: 64px;
	font-weight: 700;
	border-radius: 100px;
	cursor: pointer;
	box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	-webkit-box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	-moz-box-shadow: 10px 10px 10px 1px rgba(0, 0, 0, 0.29);
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
	border: 4px solid #f4f3f4;
	outline: 3px solid #f4f3f4;
	outline-offset: -1px;
	width: 450px;
}

.nextButton_css {
	background-color: #a20c2c;
	color: white;
	border: none;
	border-radius: 80px !important;
	padding: 0 48px !important;
	height: 100px !important;
	font-size: 60px !important;
	font-weight: bold;
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 400px !important;
	justify-content: center;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
	.text {
		margin-right: 18px;
	}
	.arrow {
		font-size: 120px;
		margin-bottom: 28px;
		font-weight: 100;
	}
}
.imageButton {
	height: 100vh;
	.v-responsive__content {
		position: relative;
		.keypad_main_layout {
			padding: 0 28px;
			position: absolute;
			top: 350px;
		}
		.clickBtn {
			position: absolute;
			bottom: 980px;
			width: 100%;
			button {
				height: 120px;
				font-size: 48px;
				font-weight: bold;
				margin: 0 auto;
				min-width: 100px;
				width: 100%;
				max-width: 710px;
				border-radius: 15px;
			}
		}
	}
	text-align: end;
	padding: 20px;
}
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
.duplicateInfo {
	font-size: 15px;
	margin-left: 16px;
	color: #808080;
}
.roullet_div {
	width: 900px;
	padding-top: 80px;
	position: relative;
}
.roullet_board {
	transform: rotate(18deg); /* 360/10/2 */
	width: 100%;
}
.roullet_arrow {
	width: 125px;
	z-index: 1;
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0%);
	top: -10px;
}
#print-background-hsgeoje,
#print-food-hsgeoje {
	display: none;
}
.event-bottom-img {
	position: absolute;
	bottom: 120px;
}
.next-button-container {
	overflow: hidden;
	display: flex;
	justify-content: center;
	margin: 20px;
	margin-bottom: 40px;
}
.reserve-background-width {
	background-color: #e6e1db; // 메인 이미지 배경(#dcd7d1) 톤
	height: 100vh;
	width: 100%;
	min-width: 900px;
	max-width: 1080px;
	margin: 0 auto;
}
/* step1 */
.content_step1 {
	background-color: #a20c2c;
	color: white;
	padding: 160px 40px 0px 40px;
	text-align: center;
}

.title-small {
	font-size: 36px;
	margin-bottom: 12px;
}

.title-large {
	font-size: 76px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.2;
}

.divider {
	width: 1px;
	height: 60px;
	background-color: #fff;
	margin: 80px auto;
}

.event-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
}
.event-bottom {
	margin: 0 150px;
}
.event-subtitle {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.3;
}

.prizes-container {
	background-color: white;
	border-radius: 30px;
	padding: 40px;
	margin-bottom: 20px;
	display: flex;
	flex-wrap: wrap;
}

.prize-item {
	width: 50%;
	padding: 20px;
	text-align: center;
}

.prize-rank {
	display: block;
	margin-bottom: 20px;
	width: 120px;
	height: 120px;
}

.prize-image {
	width: 160px;
	height: 160px;
	margin: 0 auto 20px;
}

.prize-name {
	color: #a20c2c;
	font-weight: bold;
	font-size: 32px;
	margin-bottom: 5px;
}

.prize-desc {
	color: #666;
	font-size: 28px;
}

.footnotes {
	text-align: left;
	color: #aaa;
	font-size: 16px;
	line-height: 1.5;
	white-space: pre-line;
}

/* step2 - terms page */
.content_step2_terms {
	background-color: #ffffff;
	height: 1920px;
	padding: 40px 60px 20px 60px;
	color: #4a1824;
	font-family: 'Noto Sans KR', sans-serif;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.terms-wrapper {
	width: 100%;
	max-width: 980px;
	margin: 0 auto;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.terms-title {
	font-size: 44px;
	font-weight: bold;
	color: #4a1824;
	border-bottom: 2px solid #4a1824;
	padding-bottom: 12px;
	margin: 0 0 14px;
	letter-spacing: -1px;
}

.terms-subtitle {
	font-size: 22px;
	color: #4a1824;
	margin-bottom: 22px;
	line-height: 1.4;
}

.terms-body {
	padding-left: 50px;

	p {
		margin: 0 0 2px;
		font-size: 20px;
		line-height: 1.5;
		color: #333;
	}
}

.terms-section {
	font-size: 26px;
	font-weight: bold;
	margin: 18px 0 8px;
	color: #4a1824;
	letter-spacing: -1px;
}

.terms-subsection {
	font-size: 22px !important;
	font-weight: bold;
	margin-top: 14px !important;
	margin-bottom: 4px !important;
	color: #4a1824 !important;
}

.terms-trustee-list {
	margin: 8px 0 8px;

	.terms-trustee-row {
		display: flex;
		padding: 3px 0;
		font-size: 20px;
		color: #333;

		span:first-child {
			width: 300px;
			flex-shrink: 0;
		}
	}

	.terms-trustee-header {
		font-weight: bold;
		color: #4a1824;
	}
}

.terms-agreement-table {
	width: 100%;
	border-collapse: collapse;
	border-top: 2px solid #4a1824;
	border-bottom: 2px solid #4a1824;
	margin: 8px 0 12px;
	font-size: 18px;

	th,
	td {
		padding: 8px 12px;
		border-bottom: 1px solid #d0d0d0;
		text-align: left;
		vertical-align: middle;
		color: #333;
		line-height: 1.4;
	}

	th {
		font-weight: bold;
		border-bottom: 1px solid #4a1824;
		text-align: center;
		color: #4a1824;
		background-color: #fafafa;
		padding: 8px 12px;
	}

	.col-type {
		text-align: center;
		font-weight: bold;
		width: 80px;
	}

	.col-content {
		line-height: 1.4;
	}

	.col-agree {
		width: 220px;
		white-space: nowrap;
	}

	.col-name {
		width: 100px;
	}
}

.terms-radio-option {
	cursor: pointer;
	margin-right: 12px;
	color: #4a1824;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	font-size: 18px;

	.terms-radio {
		color: #4a1824;
		font-size: 17px;

		&.active {
			color: #7a0a22;
			font-weight: bold;
		}
	}
}

.terms-notice {
	font-size: 19px !important;
	margin-top: 3px !important;
	color: #333 !important;
	font-weight: 500;
}

.terms-footnotes {
	margin-top: 12px;

	.terms-footnote {
		font-size: 15px !important;
		color: #555 !important;
		margin: 3px 0 !important;
		line-height: 1.45;
	}

	.terms-footnote-bold {
		font-size: 16px !important;
		color: #333 !important;
		margin: 8px 0 2px !important;
		font-weight: bold;
	}

	.terms-footnote-indent {
		font-size: 15px !important;
		padding-left: 14px;
		color: #555 !important;
		margin: 2px 0 !important;
		line-height: 1.45;
	}
}

.terms-final-notice {
	margin-top: 12px;

	p {
		font-size: 17px;
		margin: 3px 0;
		color: #4a1824;
		line-height: 1.45;
	}
}

.terms-button-container {
	display: flex;
	justify-content: center;
	margin-top: 16px;
	padding-top: 20px;
	padding-bottom: 6px;
}

.terms-next-button {
	background-color: #7a0a22;
	color: white;
	border: none;
	border-radius: 60px;
	padding: 0 70px;
	height: 84px;
	font-size: 40px;
	font-weight: bold;
	cursor: pointer;
	min-width: 380px;
	letter-spacing: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 개인정보 수집 및 이용 동의 (step3) */
.privacy-info-section {
	margin-top: 24px;
	padding: 0 40px;
}

.privacy-info-title {
	font-size: 28px;
	font-weight: bold;
	color: #a20c2c;
	margin-bottom: 8px;
	letter-spacing: -1px;
}

.privacy-info-table {
	width: 100%;
	border-collapse: collapse;
	border-top: 2px solid #a20c2c;
	border-bottom: 2px solid #a20c2c;
	font-size: 18px;
	background-color: #ffffff;
}

.privacy-info-table th,
.privacy-info-table td {
	padding: 10px 14px;
	border: 1px solid #c8c8c8;
	line-height: 1.5;
	vertical-align: middle;
	color: #333;
}

.privacy-info-table th {
	background-color: #f0f0f0;
	color: #a20c2c;
	font-weight: bold;
	text-align: center;
	width: 220px;
	white-space: nowrap;
}

/* 거주지역 입력 행 */
.address-display {
	width: 100%;
	min-height: 60px;
	background-color: white;
	color: #a20c2c;
	border-radius: 4px;
	padding: 12px 20px;
	font-size: 28px;
	display: flex;
	align-items: center;
}

.address-select-btn {
	width: 100%;
	height: 70px;
	background-color: #ffffff;
	color: #a20c2c;
	border: 2px solid #a20c2c;
	border-radius: 12px;
	font-size: 24px;
	font-weight: bold;
	cursor: pointer;
	line-height: 1.1;
}

/* 주소 선택 다이얼로그 */
.address-dialog {
	background-color: #f3efe6;
	border-radius: 16px;
	padding: 0;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
	overflow: hidden;
}

.address-dialog-content {
	background-color: #f3efe6;
	padding: 36px 32px 40px;
	position: relative;
}

.address-close-btn {
	position: absolute;
	top: 18px;
	left: 18px;
	width: 36px;
	height: 36px;
	background-color: #a20c2c;
	color: white;
	border: none;
	border-radius: 50%;
	font-size: 18px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}

.address-dialog-title {
	text-align: center;
	font-size: 32px;
	font-weight: bold;
	color: #a20c2c;
	margin-bottom: 6px;
}

.address-dialog-step {
	font-size: 22px;
	color: #777;
	font-weight: normal;
}

.address-dialog-subtitle {
	text-align: center;
	font-size: 22px;
	color: #a20c2c;
	margin-bottom: 24px;
	border-bottom: 1.5px solid #a20c2c;
	padding-bottom: 14px;
}

.address-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 10px;
	max-height: 70vh;
	overflow-y: auto;
}
// 1단계 지역(거제 / 통영 / 부산강서 / 기타지역): 큰 버튼 4개
.address-grid-area {
	grid-template-columns: repeat(4, 1fr);
	.address-grid-btn {
		height: 110px;
		font-size: 34px;
		font-weight: 900;
	}
}
.address-dialog-subtitle {
	position: relative;
}
.address-back-btn {
	position: absolute;
	left: 0;
	top: 0;
	font-size: 22px;
	font-weight: 700;
	color: #a20c2c;
	cursor: pointer;
	padding: 0 8px;
}

.address-grid-btn {
	background-color: #ffffff;
	color: #a20c2c;
	border: 1.5px solid #a20c2c;
	border-radius: 10px;
	padding: 14px 6px;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	min-height: 56px;
	transition: all 0.15s ease;
	line-height: 1.2;
}

.address-grid-btn:hover {
	background-color: #a20c2c;
	color: white;
}

.address-grid-btn.active {
	background-color: #a20c2c;
	color: white;
	border-color: #a20c2c;
}

/* 지역/관할구 선택 버튼 */
.age-button-group {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
.age-button {
	flex: 1 1 0;
	min-width: 90px;
	background-color: #ffffff;
	color: #a20c2c;
	border: 2px solid #ffffff;
	border-radius: 10px;
	padding: 10px 4px;
	font-size: 26px;
	font-weight: 700;
	cursor: pointer;
	min-height: 56px;
	transition: all 0.15s ease;
	line-height: 1.2;
}
.age-button.active {
	background-color: #c8a05a;
	color: #ffffff;
	border-color: #c8a05a;
}

/* step2 */
.content_step2 {
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	min-height: 100vh;
	overflow: visible;
	padding: 20px 40px 20px 40px;
	color: #a20c2c;
}
.info-section {
	padding: 0px 40px 0px 40px;
}

.info-header {
	color: black;
	letter-spacing: -4px;
	font-size: 48px;
	font-weight: bold;
	margin-top: 130px !important;
	margin: 0 auto;
	width: 100%;
	margin-bottom: 12px;
	text-align: center;
}

.info-form {
	padding: 20px;
	border-radius: 16px;
	background-color: #a20c2c;
}

.form-group {
	margin-bottom: 20px;
}

.form-label {
	color: white;
	display: block;
	font-size: 32px;
	width: 150px;
	min-width: 150px;
}

.form-input {
	width: 100%;
	height: 80px;
	padding: 10px 20px;
	font-size: 30px;
	border: 1px solid #ccc;
	background-color: white;
	color: black;
}

.info-desc {
	padding: 0px 40px 20px 40px;
	font-size: 28px;
	line-height: 1.6;
	color: #333;
}

/* 동의 섹션 스타일 */
.consent-section {
	margin-bottom: 24px;
}

.consent-header {
	font-size: 22px;
	font-weight: 900;
	color: #5a3e1b;
	margin-bottom: 8px;
	letter-spacing: -1px;
}

.consent-header-icon {
	color: #5a3e1b;
	margin-right: 4px;
}

.consent-description {
	font-size: 14px;
	font-weight: bold;
	color: #222;
	line-height: 1.8;
	margin-bottom: 12px;
	letter-spacing: -0.5px;
}

.consent-table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 0;
	border-top: 3px solid #5a3e1b;
	border-bottom: 2px solid #999;
}

.consent-table th,
.consent-table td {
	padding: 12px 16px;
	text-align: left;
	border: 1px solid #bbb;
	font-size: 15px;
	font-weight: bold;
	letter-spacing: -0.5px;
	color: #222;
	white-space: pre-line;
	vertical-align: middle;
}

.consent-table th {
	background-color: #f2f2f2;
	color: #222;
	font-weight: 900;
	width: 32%;
	text-align: center;
	border-right: 1px solid #bbb;
}

.consent-table td {
	background-color: #fff;
}

/* 첫 번째 행 (수집·이용하는 자) - 갈색 헤더 */
.consent-table-header-row th {
	background-color: #7a6140;
	color: #fff;
	font-size: 15px;
	border-color: #7a6140;
}

.consent-table-header-row td {
	background-color: #f0ebe4;
	font-weight: 900;
	color: #222;
	border-color: #bbb;
}

.consent-agree-row {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 6px 0;
	gap: 48px;
}

.consent-agree-label {
	font-size: 17px;
	font-weight: 900;
	color: #5a3e1b;
	letter-spacing: -0.5px;
}

.consent-agree-options {
	display: flex;
	gap: 36px;
}

.consent-option {
	font-size: 17px;
	font-weight: bold;
	color: #333;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 6px;
}

.consent-option.active {
	font-weight: bold;
	color: #5a3e1b;
}

.consent-radio {
	font-size: 16px;
}

.next-button {
	display: block;
	width: 350px;
	height: 80px;
	background-color: #a20c2c;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}

/* step3 */
.content_step3 {
	height: 100vh;
	overflow: hidden;
	padding: 140px 120px 0 120px;
	background-color: #e6e1db;
	color: #a20c2c;
}
.auth-header {
	.bold {
		font-weight: bold;
	}
	background-color: #f1ebe5;
	border-radius: 16px;
	padding: 24px 48px 24px 48px;
	width: 100%;
	text-align: center;
	margin-bottom: 50px;
}

.auth-header h1 {
	font-size: 80px;
	font-weight: bold;
	color: #a20c2c;
	margin-bottom: 25px;
}

.auth-header p {
	font-size: 30px;
	color: black;
	line-height: 1.5;
	margin-bottom: 0px !important;
}

.auth-form {
	background-color: #a20c2c;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px;
}

.auth-input-container {
	padding: 0 26px;
	width: 100%;
}

#auth-input {
	width: 100%;
	height: 120px;
	background-color: #f6f1eb;
	border: 1px solid #ccc;
	font-size: 50px;
	text-align: center;
	letter-spacing: 10px;
	outline: none;
	cursor: default;
	color: black;
}

.keypad {
	width: 100%;
	background-color: #a20c2c;
	border-radius: 10px;
	padding: 20px;
}

.keypad-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
}

.keypad-row:last-child {
	margin-bottom: 0;
}

.key {
	flex: 1;
	height: 150px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	color: #000;
	border: #000 1px solid;
	font-size: 70px;
	font-weight: bold;
	margin: 0 8px;
	cursor: pointer;
	user-select: none;
	text-align: center;
}

.clear-key {
	font-size: 40px;
	line-height: 1.2;
}

.backspace-key {
	font-size: 55px;
}

.key:active {
	background-color: #999999;
}

.action-button-container {
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 70px auto;
}
.action-button-outlined {
	width: 400px;
	height: 100px;
	background-color: white;
	color: #a20c2c;
	border: border 1px solid #a20c2c;
	border-radius: 80px;
	font-size: 64px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}
.action-button {
	width: 350px;
	height: 80px;
	background-color: #a20c2c;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}

.action-button:hover {
	background-color: #a20c2c;
}

/* step4 */
.title-container {
	text-align: center;
}

.main-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
	letter-spacing: -1px;
}

.sub-title {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 100px;
}

.schedule-table {
	width: 100%;
	max-width: 850px;
	margin: 0 auto;
	margin-bottom: 100px;
}

.schedule-table th,
.schedule-table td {
	text-align: center;
	vertical-align: middle;
	height: 140px;
	font-size: 50px;
	font-weight: bold;
}

.schedule-table th {
	background-color: #d5d5d5;
	color: #a20c2c;
}

.schedule-table td {
	background-color: white;
	color: #a20c2c;
}

.date {
	font-size: 60px;
}

.day {
	font-size: 40px;
	display: block;
	margin-bottom: 16px;
}

.button-container {
	margin: 100px 0;
}

.reservation-button {
	background-color: white;
	color: #a20c2c;
	padding: 4px 0;
	width: 400px;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
}
.divider-width {
	margin: 0 auto;
	max-width: 850px;
	width: 100%;
	height: 1px;
	background-color: #fff;
}
.info-block {
	width: 100%;
	max-width: 850px;
	background-color: #d5d5d5;
	color: #a20c2c;
	padding: 8px 0;
	text-align: center;
	font-size: 48px;
	font-weight: bold;
	margin: 0 auto;
}

.house-info {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	font-size: 57px;
}

.house-separator {
	margin: 0;
}

.contact-number {
	font-size: 120px;
	font-weight: bold;
	margin-bottom: 160px;
}
/* 개인정보 수집·이용 동의 (약관) - 기본 정보 입력 하단 */
// 섹션 제목(| 기본 정보 입력 | 등) 위 여백: 공용 130px → 80px (1080x1920 키오스크 한 화면에 맞춤, 스크롤 방지)
// scoped 라 이 화면에만 적용되고, 공용 .info-header 가 !important 라 같이 !important 사용
.info-header {
	margin-top: 80px !important;
}
// 기본 정보 입력 화면이 1920px 안에 스크롤 없이 들어오도록 여백 축소 (주소/푸드트럭 행 추가분)
.content_step2 {
	.info-header {
		margin-top: 40px !important;
	}
	.hsgeoje-terms .info-header {
		margin-top: 24px !important;
	}
	.info-desc {
		padding-bottom: 0;
	}
	.next-button-container {
		margin-bottom: 20px;
	}
}

.hsgeoje-terms {
	margin-top: 0;
}
// 약관 2단 ([필수] / [선택])
.hsgeoje-terms.info-section {
	padding: 0; // 2단 약관은 폭을 넓게 (920 → 1000px)
}
.hsgeoje-terms-cols {
	display: flex;
	gap: 18px;
	margin-top: 8px;
	word-break: keep-all;
}
.hsgeoje-term {
	flex: 1;
	min-width: 0;
	color: #222;
	display: flex;
	flex-direction: column;
}
.hsgeoje-term-title {
	font-size: 22px;
	font-weight: 900;
	color: #222;
	letter-spacing: -0.03em;
	margin-bottom: 8px;
	white-space: nowrap;
}
.hsgeoje-term-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 17px;
	line-height: 1.35;
	border-top: 2px solid #4a4a4a;
	tr {
		height: 62px; // 두 박스 행 높이 동일 (최대 2줄)
	}
	tr:first-child {
		height: 84px; // 수집·이용 주체 (필수는 코비플랜까지 3줄) — 좌우 박스 높이를 맞추기 위해 양쪽 동일
	}
	th,
	td {
		border-bottom: 1px solid #a9a39d;
		padding: 7px 10px;
		vertical-align: middle;
	}
	th {
		width: 33%;
		background-color: #d9d3cc;
		font-weight: 700;
		text-align: center;
		border-right: 1px solid #a9a39d;
	}
	td {
		background-color: #ffffff;
		text-align: left;
		letter-spacing: -0.03em;
	}
}
.hsgeoje-term-quote {
	color: #a20c2c;
	font-weight: 900;
}
.hsgeoje-term-note {
	flex: 1; // 남는 높이를 채워 아래 동의 바 위치를 양쪽 동일하게
	font-size: 15px;
	color: #555;
	line-height: 1.45;
	margin: 10px 0;
	span + span {
		padding-left: 14px;
	}
}
.hsgeoje-term-agree {
	border-top: 2px solid #4a4a4a;
	border-bottom: 1px solid #a9a39d;
	text-align: center;
}
.hsgeoje-term-q {
	background-color: #d9d3cc;
	font-size: 17px;
	font-weight: 800;
	padding: 8px 6px;
	letter-spacing: -0.03em;
	white-space: nowrap;
}
.hsgeoje-term-options {
	display: flex;
	justify-content: center;
	gap: 26px;
	background-color: #ffffff;
	padding: 8px 0;
}
.hsgeoje-term-option {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: 20px;
	font-weight: 700;
	cursor: pointer;
	padding: 4px 6px;
}
.hsgeoje-term-check {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border: 2px solid #4a4a4a;
	border-radius: 4px;
	background: #ffffff;
	color: #ffffff;
	font-size: 20px;
	&.active {
		background: #a20c2c;
		border-color: #a20c2c;
	}
}
// 주소 / 푸드트럭 이용권 선택 버튼 (버건디 입력 패널 위)
.form-label-small {
	font-size: 26px !important;
	line-height: 1.2;
}
.choice-group {
	display: flex;
	flex: 1;
	gap: 14px;
}
.choice-btn {
	flex: 1;
	height: 64px;
	border-radius: 12px;
	border: 2px solid #ffffff;
	background: transparent;
	color: #ffffff;
	font-size: 30px;
	font-weight: 800;
}
.choice-btn.active {
	background: #ffffff;
	color: #a20c2c;
}
</style>
